import { env } from '@/config/env';
import { loggedOut } from '@/slices/auth/constants/sessionSlice';

// GraphQL fails with HTTP 200 and an `errors` array, so every response is checked here.
export const graphqlBaseQuery = async ({ document, variables }, api) => {
  let response;
  try {
    response = await fetch(env.graphqlUrl, {
      method: 'POST',
      credentials: 'include', // carries the httpOnly session cookie
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: document, variables }),
      signal: api.signal,
    });
  } catch (error) {
    return { error: { status: 'FETCH_ERROR', message: error.message } };
  }

  if (!response.ok) {
    return { error: { status: response.status, message: response.statusText } };
  }

  let body;
  try {
    body = await response.json();
  } catch (error) {
    return { error: { status: 'PARSING_ERROR', message: error.message } };
  }

  if (body.errors?.length) {
    const [first] = body.errors;
    const code = first.extensions?.code;

    // Mirrors what baseQueryWithReauth does for a REST 401.
    if (code === 'UNAUTHENTICATED') {
      api.dispatch(loggedOut());
    }

    return {
      error: {
        status: code ?? 'GRAPHQL_ERROR',
        message: first.message,
        errors: body.errors,
      },
    };
  }

  return { data: body.data };
};
